import { Container } from "@mui/material";
import { useContext, useEffect } from "react";
import { fetchKV } from "../api/kv";
import SEO from "../components/SEO";
import { SiteStateContext } from "../contexts/SiteStateContext";
import gaEvents from "../util/gaEvent";
import { fixSiteState } from "../util/site_state";

export function NewsPage() {
    const { setSiteState } = useContext(SiteStateContext);

    useEffect(() => {
        if (setSiteState) {
            setSiteState(fixSiteState({ title: "News", navHighlight: "/news", hideFooter: true }));
        }

        fetchKV("mailchimpLatestCampaignUrl").then((url) => {
            window.location.href = url;
        });
    }, [setSiteState]);

    gaEvents.newsletter.newsletter_open();

    return (
        <Container sx={{ mt: "60px", textAlign: "center" }}>
            <SEO 
                title="News - River Hawk Chapter"
                description="Stay updated with the latest news and announcements from River Hawk Chapter of the Order of the Arrow."
                keywords="River Hawk News, OA News, Chapter Updates, Scout News, Order of the Arrow Announcements"
            />
            Redirecting...
        </Container>
    );
}
